<template>
  <div class="content insurance-detail-page">
    <div class="body">
      <Tabs v-model="tabActive" @on-click="changeTab">
        <TabPane label="基本信息" name="1">
          <baseInfo ref="baseRef" />
        </TabPane>
        <TabPane label="品牌介绍" name="2">
          <insuranceCompanyInstructions ref="insuranceCompanyInstructions" />
        </TabPane>
        <TabPane label="信息汇总" name="3">
          <insuranceCompanyInfoCollect ref="insuranceCompanyInfoCollect" />
        </TabPane>
        <TabPane label="保司新闻" name="4">
          <insuranceCompanyNews ref="insuranceCompanyNews" />
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>
    <script>
import baseInfo from './components/base';
import insuranceCompanyInstructions from './components/insuranceCompanyInstructions';
import insuranceCompanyInfoCollect from './components/insuranceCompanyInfoCollect';
import insuranceCompanyNews from './components/insuranceCompanyNews';
export default {
  components: { baseInfo, insuranceCompanyInstructions, insuranceCompanyInfoCollect,insuranceCompanyNews },
  data: () => ({
    tabActive: '1',
    id: ''
  }),
  mounted() {
    this.id = this.$route.query.id;
    this.$nextTick(() => {
      this.$refs.baseRef.init({ id: this.id });
    });
  },
  methods: {
    async changeTab(val) {
      if (val == 2) {
        this.$refs.insuranceCompanyInstructions.init({ id: this.id });
      } else if (val == 3) {
        this.$refs.insuranceCompanyInfoCollect.init({ id: this.id });
      } else if (val == 1) {
        this.$refs.baseRef.init({ id: this.id });
      } else if (val == 4) {
        this.$refs.insuranceCompanyNews.init({ id: this.id });
      }
    }
  }
};
</script>
    <style lang='scss' scoped>
@import './detail';
</style>